import React from 'react';
import {Text} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {SingleValueControl} from './SingleValueControl';
import {GridContainer} from '../../../common/GridLayout/GridLayout';
import {texts} from '../../../../texts';
import {OldZoomValues} from '../../enum';

type Props = {
    value: string;
    secondValue: string;
    onChange: (value: string, name: string) => void;
    name: string;
    secondName: string;
    zoom?: priority.netitems.form.ZoomType | OldZoomValues;
    relatedField?: number;
    isBPM?: boolean;
};

const style = {
    gridTemplateColumns: 'minMax(0, 1fr) auto minMax(0, 1fr)'
};

export const RangeValueControl = (props: Props) => {
    const {onChange, secondValue, value, secondName, name, zoom, relatedField, isBPM} = props;

    return (
        <GridContainer columnCount={0} style={style}>
            <SingleValueControl
                relatedField={relatedField}
                zoom={zoom}
                onChange={onChange}
                value={value}
                name={name}
                isBPM={isBPM}
            />

            <Text tag="span" skin="paragraph-2" textColor="secondary-400">
                {texts.falls_between_and_operator_label.toLocaleLowerCase()}
            </Text>

            <SingleValueControl
                relatedField={relatedField}
                zoom={zoom}
                onChange={onChange}
                value={secondValue}
                name={secondName}
                isBPM={isBPM}
            />
        </GridContainer>
    );
};
